<account-page title="Welcome {{ permissionsService.user.name }}" subtitle="Guest management and payment setup">
  @if (date) {
    <countdown [date]="date"></countdown>
  }
  <guests-table-component></guests-table-component>
  <raised-button [styles]="{ width: '100%' }" color="primary" (click)="setupPayments()">Setup Payments</raised-button>
</account-page>
